import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { TGetTagsFailed, EGetTagsActionType } from './types';

export const getTagsFailed: () => TGetTagsFailed = actionGenerator<EGetTagsActionType.Failed>(
  EGetTagsActionType.Failed,
);
